import { KeysResponse } from './keysResponse';

export class OrganizationKeysResponse extends KeysResponse {
    constructor(response: any) {
        super(response);
    }
}
